<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-6" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="$router.push('calendars/create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('common_words.calendar_add') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="calendarsSelected"
            :visible.sync="modals.read"
            width="70%"
            top="2%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card mb-3" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <div class="row mb-2">
                          <div class="col-sm-12 col-md-4">
                            <h6 class="mb-2">
                              <strong>{{ $t('common_words.name') }}:</strong>
                            </h6>
                            {{ rowData.name }}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-12">
                            <h6 class="mb-2">
                              <strong
                                >{{
                                  $t('common_words.associated_farms')
                                }}:</strong
                              >
                            </h6>
                            <span
                              v-for="(f, index) in rowData.farm_names"
                              :key="index"
                            >
                              <el-tag type="info">{{ f }}</el-tag>
                            </span>
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-12">
                            <h6 class="mb-2">
                              <strong
                                >{{
                                  $t('common_words.associated_companies')
                                }}:</strong
                              >
                            </h6>
                            <span
                              v-for="(b, index) in rowData.business_names"
                              :key="index"
                            >
                              <el-tag type="info">{{ b }}</el-tag>
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at">
                <p class="text-muted">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <p>{{ $t('common_words.year_selection') }}:</p>
                <el-select
                  clearable
                  filterable
                  class="select-default mb-4 shadow-sm select-input-text-center"
                  v-model="calendarForm.anio_sel"
                  @change="loadCalendar"
                >
                  <el-option
                    class="select-default text-center"
                    v-for="(item, index) in anios"
                    :key="index"
                    :label="item.anio"
                    :value="item.anio"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="card"
              v-if="rowData && Object.keys(details).length > 0"
              style="border: none"
            >
              <div class="row" v-for="item in 4" :key="item">
                <div
                  class="col-xs-12 col-sm-4 col-md-4 text-center mb-4"
                  v-for="(m, i) in months[item - 1]"
                  :key="i"
                >
                  <table class="full-width" cellpadding="3" align="center">
                    <tr>
                      <td class="monthtittle text-center">
                        <strong>{{ m }}</strong>
                      </td>
                    </tr>
                  </table>

                  <table
                    class="full-width"
                    cellpadding="3"
                    cellspacing="0"
                    align="center"
                  >
                    <tr>
                      <td class="daytt text-center"></td>
                      <td class="daytt text-center"></td>
                      <td
                        class="daytt text-center"
                        v-for="(day, index) in headers"
                        :key="index"
                      >
                        {{ day }}
                      </td>
                    </tr>
                  </table>

                  <span
                    class="each"
                    v-bind:id="m.toLowerCase() + 'deta'"
                  ></span>
                </div>
              </div>
            </div>
            <div v-else class="text-center">
              <p>
                {{ $t('common_words.calendar_selected_info') }}
              </p>
            </div>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              filterable
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              max-height="500"
              style="width: 100%"
              border
            >
              <el-table-column
                type="index"
                width="65"
                :resizable="false"
                align="center"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              >
              </el-table-column>
              <el-table-column
                min-width="80"
                prop="props.business_names"
                :label="$t('common_words.associated_companies')"
                :sortable="true"
                :resizable="false"
                align="center"
              >
                <template slot-scope="scope">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="scope.row.business_names.length > 0"
                    :hidden="
                      scope.row.business_names.length == 1 ? true : false
                    "
                    :value="200"
                    :max="scope.row.business_names.length - 1"
                  >
                    <el-button plain type="info" size="small">
                      {{ scope.row.business_names[0] }}</el-button
                    >
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                min-width="80"
                prop="props.farm_names"
                :label="$t('common_words.associated_farms')"
                :sortable="true"
                :resizable="false"
                align="center"
              >
                <template slot-scope="scope">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="scope.row.farm_names.length > 0"
                    :hidden="scope.row.farm_names.length == 1 ? true : false"
                    :value="200"
                    :max="scope.row.farm_names.length - 1"
                  >
                    <el-button plain type="info" size="small">
                      {{ scope.row.farm_names[0] }}</el-button
                    >
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                v-if="isShow() || isUpdate() || isDelete()"
                :min-width="60"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { Pagination as LPagination } from 'src/components/index';
import SweetAlert from 'src/class/Alerts';
import configTable from './calendarsTable';
import Fuse from 'fuse.js';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import { MixinExport } from 'src/mixins/mixin-export';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },
  computed: {
    ...configTable().Search,

    calendarsSelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },

    months() {
      return {
        0: {
          1: i18n.t('months.january'),
          5: i18n.t('months.may'),
          9: i18n.t('months.september'),
        },
        1: {
          2: i18n.t('months.february'),
          6: i18n.t('months.june'),
          10: i18n.t('months.october'),
        },
        2: {
          3: i18n.t('months.march'),
          7: i18n.t('months.july'),
          11: i18n.t('months.november'),
        },
        3: {
          4: i18n.t('months.april'),
          8: i18n.t('months.august'),
          12: i18n.t('months.december'),
        },
      };
    },
  },
  data() {
    return {
      calendarForm: {
        name: null,
        anio_sel: null,
      },
      title: null,
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
        create: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
      anios: [],
      details: [],
      headers: [],
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleView(index, row) {
      this.showHideLoading(true);
      Axios.getMasters('calendars/get_years/' + row.id)
        .then((response) => {
          this.anios = response.data;
          this.rowData = row;
          this.rowData.created_at = moment(
            String(this.rowData.created_at),
            'YYYY-MM-DD HH:mm:ss'
          ).format('YYYY-MM-DD hh:mm:ss');
          this.modals['read'] = true;

          if (this.anios.length > 0) {
            this.calendarForm.anio_sel = this.anios[0].anio;

            Axios.getMasters(
              'calendars/details/' +
                this.rowData.id +
                '/' +
                this.calendarForm.anio_sel
            )
              .then((resp) => {
                this.details = resp.data.calendar_details;
                this.headers = resp.data.headers;
                this.fillCalendar(resp.data.dayEndWeek);
              })
              .catch((error) => {
                this.showHideLoading();
                console.log(error);
              });
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    handleEdit(index, row) {
      row.url_path_form = '/calendars/edit';
      this.calendarForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.calendarForm));
      this.$router.push({
        path: 'calendars/edit',
      });
    },

    handleDelete(index, row) {
      this.calendarForm = row;
      SweetAlert.delete(
        i18n.t('common_words.the_calendar') + this.calendarForm.name
      ).then((result) => {
        if (result.value) this.deleteCalendar();
      });
    },

    deleteCalendar() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.calendarForm.route = 'calendars';
        Axios.destroyMaster(this.calendarForm)
          .then((response) =>
            this.modifyTable(2, this.calendarForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      this.PDF({
        route: 'calendars/pdf',
        name_file: 'calendarios.pdf',
      })
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      this.Excel({
        route: 'calendars/excel',
        name_file: 'calendarios.xlsx',
      })
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    loadCalendar() {
      this.showHideLoading(true);
      Axios.getMasters(
        'calendars/details/' +
          this.rowData.id +
          '/' +
          this.calendarForm.anio_sel
      )
        .then((resp) => {
          this.details = resp.data.calendar_details;
          this.headers = resp.data.headers;
          this.fillCalendar(resp.data.dayEndWeek);
          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    fillCalendar(dayEndWeek) {
      this.showHideLoading(true);

      let html =
        '<table class="full-width" cellpadding="3" cellspacing="0" align="center">' +
        '<tr>' +
        '<td class="calsec text-center"><strong>#ciclo#</strong></td>' +
        '<td class="dayt text-center" style="background-color:#ci#;color:#ct#">#se#</td> ';

      Object.keys(this.headers).forEach((key) => {
        html +=
          '<td class="dayt text-center ' +
          (key == 'j' || key == 'v' || key == 's' ? 'daysgray' : '') +
          '">#' +
          key +
          '#</td> ';
      });

      html += '</tr></table>';

      let mes = parseInt(this.calendarForm.anio_sel) * 100 + 1;
      let dt = html;
      let semana = 1;
      let i = 0;
      let j = 1;
      let d = '';
      let expr = '';
      let ene = [];
      let feb = [];
      let mar = [];
      let abr = [];
      let may = [];
      let jun = [];
      let jul = [];
      let ago = [];
      let sep = [];
      let oct = [];
      let nov = [];
      let dic = [];
      let nregistros = this.details.length;
      let ultsem = 0;

      this.details.forEach((element) => {
        if (element.year * 100 + element.month > mes) {
          dt = dt.replace('#ciclo#', '');
          dt = dt.replace('#ci#', element.ribbon.color_code);
          dt = dt.replace('#ct#', element.ribbon.color_text);
          dt = dt.replace('#se#', element.week);
          dt = dt.replace('#d#', '');
          dt = dt.replace('#l#', '');
          dt = dt.replace('#ma#', '');
          dt = dt.replace('#mi#', '');
          dt = dt.replace('#j#', '');
          dt = dt.replace('#v#', '');
          dt = dt.replace('#s#', '');

          if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 1)
            ene.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 2)
            feb.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 3)
            mar.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 4)
            abr.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 5)
            may.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 6)
            jun.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 7)
            jul.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 8)
            ago.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 9)
            sep.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 10)
            oct.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 11)
            nov.push(dt);
          else if (mes == parseInt(this.calendarForm.anio_sel) * 100 + 12)
            dic.push(dt);
          mes++;
          dt = html;
        }

        if (element.dayofweek == 1) {
          d = element.day;
          expr = '#l#';
        } else {
          if (element.dayofweek == 2) {
            d = element.day;
            expr = '#ma#';
          } else {
            if (element.dayofweek == 3) {
              d = element.day;
              expr = '#mi#';
            } else {
              if (element.dayofweek == 4) {
                d = element.day;
                expr = '#j#';
              } else {
                if (element.dayofweek == 5) {
                  d = element.day;
                  expr = '#v#';
                } else {
                  if (element.dayofweek == 6) {
                    d = element.day;
                    expr = '#s#';
                  } else {
                    if (element.dayofweek == 0) {
                      d = element.day;
                      expr = '#d#';
                    }
                  }
                }
              }
            }
          }
        }

        dt = dt.replace(expr, d);
        dt = dt.replace('#ci#', element.ribbon.color_code);
        dt = dt.replace('#ct#', element.ribbon.color_text);

        if (j == 1) {
          if (
            semana == 1 ||
            semana == 5 ||
            semana == 9 ||
            semana == 13 ||
            semana == 17 ||
            semana == 21 ||
            semana == 25 ||
            semana == 29 ||
            semana == 33 ||
            semana == 37 ||
            semana == 41 ||
            semana == 45 ||
            semana == 49
          ) {
            dt = dt.replace('#ciclo#', element.cycle);
          }
        } else {
          dt = dt.replace('#ciclo#', '');
        }

        j = 0;

        if (element.dayofweek == dayEndWeek) {
          semana++;
          j = 1;
        }

        semana =
          (ultsem == 52 || ultsem == 53) && element.week == 1
            ? element.week
            : semana;

        if (ultsem == 52 || ultsem == 53) {
          mes = (parseInt(this.calendarForm.anio_sel) + 1) * 100 + 1;
        }

        if (element.week < semana) {
          if (i < nregistros - 1) {
            dt = dt.replace('#ci#', element.ribbon.color_code);
            dt = dt.replace('#ct#', element.ribbon.color_text);
            dt = dt.replace('#se#', element.week);
            dt = dt.replace('#d#', '');
            dt = dt.replace('#l#', '');
            dt = dt.replace('#ma#', '');
            dt = dt.replace('#mi#', '');
            dt = dt.replace('#j#', '');
            dt = dt.replace('#v#', '');
            dt = dt.replace('#s#', '');

            //if ((element.day != new Date(element.year + '-' + (element.month) + '-1').getDay()))
            dt = dt + html;
          }
        }

        ultsem = element.week;
        i++;
      });

      dt = dt.replace('#ciclo#', '');
      dt = dt.replace('#se#', ultsem);
      dt = dt.replace('#d#', '');
      dt = dt.replace('#l#', '');
      dt = dt.replace('#ma#', '');
      dt = dt.replace('#mi#', '');
      dt = dt.replace('#j#', '');
      dt = dt.replace('#v#', '');
      dt = dt.replace('#s#', '');

      dic.push(dt);

      setTimeout(() => {
        document.getElementById('enerodeta').innerHTML = ene;
        document.getElementById('febrerodeta').innerHTML = feb;
        document.getElementById('marzodeta').innerHTML = mar;
        document.getElementById('abrildeta').innerHTML = abr;
        document.getElementById('mayodeta').innerHTML = may;
        document.getElementById('juniodeta').innerHTML = jun;
        document.getElementById('juliodeta').innerHTML = jul;
        document.getElementById('agostodeta').innerHTML = ago;
        document.getElementById('septiembredeta').innerHTML = sep;
        document.getElementById('octubredeta').innerHTML = oct;
        document.getElementById('noviembredeta').innerHTML = nov;
        document.getElementById('diciembredeta').innerHTML = dic;
        this.showHideLoading();
      }, 500);
    },
    setupTable() {
      const { Table } = configTable();
      // Assign the Table and Search objects to your data properties
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('calendars')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns
              .map((prop) => {
                return prop.prop;
              })
              .concat(['business_names', 'farm_names']),
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('calendars');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('calendars');
  },
};
</script>
<style></style>
